<template>
  <header class="mod-page-title pega-header">
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area"
    >
      <preview-text-count
        name="職種名"
        class="mt50"
        :count-target="jobName"
      />
    </div>
    <p class="corp-name mt2">
      <a
        class="corp-link base_gray size-14px weight-bold"
        data-test="company-name"
        v-text="companyName"
      />
    </p>
    <section style="display:table; margin-bottom:0;">
      <section
        class="head_upr detail pull-left clearfix mt10 mb0"
        style="width:550px; display:table-cell;"
      >
        <h1
          :id="targetIdMap.jobName"
          class="jobname left base_gray pull-left size-xxxlarge title"
          data-test="job-name"
          v-text="jobName.value"
        />
        <ul class="icon left pull-left">
          <li
            v-for="(employment,i) in displayEmploymentStatus"
            :key="i"
            :data-test="`employment-${i}`"
            class="ico_sts"
            v-text="employment"
          />
          <li
            v-if="isSimpleTypeEntryFrom"
            class="ico_tps simple"
            data-test="simple"
            v-text="'自己PR不要'"
          />
          <li
            v-if="isLightTypeEntryForm"
            class="ico_tps light"
            data-test="light"
            v-text="'自己PRと職歴不要'"
          />
          <li
            v-if="canCasualInterview"
            class="ico_tps"
            data-test="casual-interview"
            v-text="'話を聞きたい応募可'"
          />
          <li class="mt4">
            <template v-if="isShowSalaryMap">
              <img
                class="icon-img"
                alt="¥"
                :src="userEndPoint + salaryIcon"
              >
              <span
                :id="targetIdMap.salaryMap"
                data-test="salary"
              >年収：{{ salaryMap.min }}~{{ salaryMap.max }}万円</span>
            </template>
            <template v-if="overtimeWorkHours">
              <img
                class="icon-img"
                alt="残業"
                :src="userEndPoint + overtimeWorkHoursIcon"
              >
              <span
                :id="targetIdMap.overtimeWorkHours"
                data-test="overtime-work-hours"
              >目安残業時間：{{ overtimeWorkHours }}</span>
            </template>
          </li>
        </ul>
      </section>
      <section
        class="head_udr pt15 clearfix"
        style="display:table-cell; vertical-align:top;"
      >
        <div
          class="right pull-right align-center pb3"
          :class="[{'non-casual-interview':!canCasualInterview}]"
        >
          <ul class="button_area clearfix pull-right">
            <li
              v-if="canCasualInterview"
              class="form_btn"
              data-test="casual-interview-button"
            >
              <a class="mod-button casual-interview-button js-over pb4 pr3 pl3 pt7">
                <img
                  :src="`${userEndPoint}/common/img/module/interview.png`"
                  class="casual-interview-icon"
                >
                <span class="align-middle line-height-init">話を聞きたい</span>
              </a>
            </li>
            <li
              class="form_btn"
              style="width:191px;"
            >
              <!-- シンプル応募 -->
              <a
                v-if="isSimpleTypeEntryFrom"
                class="mod-button entry-button simple-button pb7 pr3 pl3 pt4"
                style="opacity:0.99;"
                data-test="simple-balloon"
              >
                <span class="entry-type-simple-text mr5 mt2 line-height-init">自己PR不要！</span><br>
                <span
                  style="vertical-align:middle;"
                  class="simple-txt align-top line-height-init"
                >応募フォームへ</span>
              </a>
              <!-- ライト応募 -->
              <a
                v-else-if="isLightTypeEntryForm"
                class="mod-button entry-button light-button pb7 pr3 pl3 pt4"
                style="opacity:0.99;"
                data-test="light-balloon"
              >
                <span class="entry-type-light-text mr5 line-height-init">自己PRと職歴不要！</span><br>
                <span
                  style="vertical-align:middle;"
                  class="light-txt align-top line-height-init"
                >応募フォームへ</span>
              </a>
              <!-- 通常応募 -->
              <a
                v-else
                class="mod-button entry-button js-over pb4 pr3 pl3 pt7"
                style="opacity:0.99;"
                data-test="normal"
              >応募フォームへ
              </a>
            </li>
            <li class="detail-bookmark-button">
              <img
                :src="`${userEndPoint}/common/img/module/bookmark_star_off.png`"
                class="book-mark is-inactive"
              >
            </li>
          </ul>
        </div>
        <ul class="icon right pull-right align-center">
          <li
            class="ico_new"
            v-text="'NEW'"
          />
          <li
            class="ico_end"
            v-text="'掲載期間：yyyy.mm.dd〜yyyy.mm.dd'"
          />
        </ul>
      </section>
    </section>
  </header>
</template>

<style lang="scss" scoped>
@use "@/styles/preview/pc/base" as *;

.icon-img{
  display: inline-block !important;
  vertical-align: -2.5px;
}
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon, jobPreviewVisibilityCommon],
  props: {
    companyName: {
      type: String,
      required: true
    },
    jobName: {
      type: Object,
      required: true
    },
    employmentStatus: {
      type: Array,
      default: () => []
    },
    salaryMap: {
      type: Object,
      default: () => {}
    },
    overtimeWorkHours: {
      type: String,
      default: ''
    },
    entryFormType: {
      type: String,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    canCasualInterview: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    },
    isClientJob: {
      type: Boolean,
      default: false
    },
    isSalaryDisplay: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    // クライアント職種で下書き保存をした場合、nullが入り得るのでフィルター
    displayEmploymentStatus () {
      return this.employmentStatus.filter(employment => employment)
    },
    isShowSalaryMap () {
      return this.isClientJob
        ? this.isSalaryDisplay
        : !!(this.salaryMap && this.salaryMap.min && this.salaryMap.max)
    },
    salaryIcon: () => '/common/img/parts/icn_fee.png',
    overtimeWorkHoursIcon: () => '/common/img/parts/icn_time.png'
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
